import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/:catchAll(.*)',
      name: 'not-found',
      component: () => import('@/views/NotFound.vue'),
      meta: {
        layout: 'Blank',
      },
    },
    {
      path: '/development',
      name: 'development',
      component: () => import('@/views/DevelopmentView.vue'),
      meta: {
        layout: 'Default',
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/AuthView.vue'),
      meta: {
        layout: 'Auth',
      },
    },
    {
      path: '/',
      redirect: { name: 'ordersCurrent' },
    },
    {
      path: '/orders',
      redirect: { name: 'ordersCurrent' },
      meta: {
        layout: 'Default',
      },
      children: [
        {
          path: 'current',
          name: 'ordersCurrent',
          components: {
            default: () => import('@/views/CurrentAnalysisView.vue'),
            LeftSidebar: () => import('@/components/AppMenu.vue'),
          },
        },
        {
          path: ':id',
          name: 'ordersItem',
          components: {
            default: () => import('@/views/OrderView.vue'),
            LeftSidebar: () => import('@/components/AppMenu.vue'),
          },
          beforeEnter(to, from) {
            if (to.params.id && /^\d+$/.test(to.params.id as string)) return true
            else {
              return from ?? '/'
            }
          },
        },
      ],
    },
    {
      path: '/ai',
      name: 'ai',
      components: {
        default: () => import('@/views/CurrentAnalysisView.vue'),
        LeftSidebar: () => import('@/components/AppMenu.vue'),
      },
      meta: {
        layout: 'Default',
      },
    },
    {
      path: '/ai-settings',
      name: 'aiSettings',
      components: {
        default: () => import('@/views/AiSettings.vue'),
      },
      meta: {
        layout: 'Default',
      },
    },
    {
      path: '/employee',
      name: 'employee',
      component: () => import('@/views/CurrentAnalysisView.vue'),
      meta: {
        layout: 'Default',
      },
    },
    {
      path: '/history',
      name: 'history',
      component: () => import('@/views/CurrentAnalysisView.vue'),
      meta: {
        layout: 'Default',
      },
    },
  ],
})

export default router
